import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const ModalBg = styled.div`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalBox = styled.div`
  z-index: 15;
  position: absolute;
  top: calc(50vh - 100px);
  left: calc(50vw - 200px);
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  width: 520px;
  height: 308px;
`;

const Title = styled.span`
  display: block;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
`;

const Content = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #8e8e8e;
  line-height: 24px;
  margin-bottom: 50px;
  text-align: center;
`;

const BtnContainer = styled.div`
  display: flex;
  gap: 29px;
`;

const Btn = styled.button`
  width: 180px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  border-radius: 37px;
  cursor: pointer;
  border: none;
`;

const CancelBtn = styled(Btn)`
  background-color: #c0c0c0;
`;

const ConfirmBtn = styled(Btn)`
  background-color: #2282e9;
  background-color: ${(props) => (props.disabled ? "#c0c0c0" : "#2282e9")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;

export default function Modal(props: any) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const onClick = () => {
    setIsLoading(true);
    props.CallAPI().then(() => {
      setIsLoading(false);
      props.close();
      navigate("/home/company-info");
    });
  };

  return (
    <ModalBg>
      <ModalBox>
        {props.isRevise ? (
          <Title>게임사 등록 수정을 완료하시겠습니까?</Title>
        ) : (
          <Title>게임사 등록을 완료하시겠습니까?</Title>
        )}
        <Content>
          게임사 심사는 영업일 기준 0-2일 정도 소요됩니다. <br />
          누락된 서류 정보가 있을시 추가 요청 드릴 수 있습니다.
        </Content>
        <BtnContainer>
          <CancelBtn onClick={() => props.close()}>취소</CancelBtn>
          <ConfirmBtn onClick={onClick} disabled={isLoading}>
            {isLoading ? "Loading..." : (props.isRevise ? "수정 완료" : "등록하기")}
          </ConfirmBtn>
        </BtnContainer>
      </ModalBox>
    </ModalBg>
  );
}
